import { Container } from '@/components/layout/Container'

export function Privacy() {
  return (
    <div className="pt-28 pb-24">
      <Container className="max-w-3xl">
        <h1 className="mb-8 font-display text-4xl normal-case text-carbon md:text-5xl">
          Privacy Policy
        </h1>
        <p className="mb-12 text-sm text-carbon/60">Last updated: October 2026</p>

        <div className="space-y-8 leading-relaxed text-carbon/70">
          <section>
            <h2 className="mb-3 font-display text-xl text-carbon">1. Information we collect</h2>
            <p>
              We collect information you provide directly, such as your name, email address, phone
              number, and shipping address when you create an account, place an order, or subscribe
              to our journal notes. We also collect payment transaction references and order history.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-xl text-carbon">2. How we use your information</h2>
            <p>
              We use your information to process orders, arrange delivery, communicate with you
              about your purchases, and send marketing updates only where you have consented. We do
              not sell your personal information.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-xl text-carbon">3. Third-party services</h2>
            <p>
              We use trusted services for payments (Paystack), email (Brevo), shipping logistics,
              and authentication (Google). These providers process data only as needed to perform
              their services and are bound by their own privacy commitments.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-xl text-carbon">4. Security</h2>
            <p>
              We protect your data using encryption in transit, secure authentication, and access
              controls. Only authorised team members can access order and customer data.
            </p>
          </section>

          <section>
            <h2 className="mb-3 font-display text-xl text-carbon">5. Your rights</h2>
            <p>
              You may request access to, correction of, or deletion of your personal data by contacting
              us at hello@littlesky.com.
            </p>
          </section>
        </div>
      </Container>
    </div>
  )
}
